import React, { ReactElement } from "react";

import Container from "@mui/material/Container";
import Divider from "@mui/material/Divider";
import Toolbar from "@mui/material/Toolbar";
import Typography from "@mui/material/Typography";
import { useTheme } from "@mui/material/styles";
import useMediaQuery from "@mui/material/useMediaQuery";

type SectionComponentProps = {
  value: string;
  index: string;
  title: string;
  children?: React.ReactNode;
};

export const TabSection = ({
  value,
  index,
  title,
  children,
}: SectionComponentProps): ReactElement => {
  const theme = useTheme();
  const isDesktop = useMediaQuery(theme.breakpoints.up("md"));

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`tabpanel-${index}`}
      aria-labelledby={`tab-${index}`}
    >
      {title && (
        <>
          {isDesktop ? (
            <>
              <Toolbar>
                <Typography
                  variant="h4"
                  component="h2"
                  sx={{
                    margin: 0,
                    padding: 0,
                  }}
                >
                  {title}
                </Typography>
              </Toolbar>
              <Divider />
            </>
          ) : (
            <h2 className="sr-only">{title}</h2>
          )}
        </>
      )}
      <Container
        maxWidth={false}
        sx={{
          padding: 2,
          paddingLeft: "24px",
        }}
      >
        {children}
      </Container>
    </div>
  );
};
export default TabSection;
